module.exports = __webpack_public_path__ + "img/mobile_banner.943bd3b6.jpg";